export const SCREENS = {
  sm: 390,
  md: 768,
  lg: 1024,
  xl: 1440,
  '2xl': 1920,
} as const;
